export const props = {
    macroList: {
        type: Array,
        default: function () {
            return []
        }
    },
    icon: {
        type: String,
        default: "macro-icon"
    },
    label: {
        type: String,
        default: "More Actions"
    }
}